import {SyntheticEvent, useCallback, useEffect, useRef, useState} from 'react';
import {UserDTO, ModelDTO} from 'hemwb-api';

export const useSideBarModal = (...dependencies: any[]) => {
  const [isOpen, setIsOpen] = useState(false);
  const [buttonPosition, setButtonPosition] = useState<{top: number; element: Element} | undefined>();
  const [user, setUser] = useState<UserDTO>();
  const [model, setModelId] = useState<ModelDTO>();
  const prevDepsRef = useRef<string | undefined>(dependencies[0] ? String(dependencies[0]) : undefined);

  useEffect(() => {
    const currentDepKey = dependencies[0] ? String(dependencies[0]) : undefined;

    // Only close modal if navigating to a different model
    if (isOpen && prevDepsRef.current !== currentDepKey && currentDepKey !== undefined) {
      setIsOpen(false);
      setButtonPosition(undefined);
    }

    prevDepsRef.current = currentDepKey;
  }, [dependencies[0], isOpen]);

  const openModal = useCallback((event: SyntheticEvent, userInfo?: any, models?: any) => {
    const element = event.currentTarget;
    const rect = element.getBoundingClientRect();

    // Capture position immediately before element might be destroyed
    setButtonPosition({
      top: rect.top,
      element: element, // Keep a reference for initial positioning
    });
    setIsOpen(true);
    setModelId(models);
    if (userInfo) {
      setUser(userInfo);
    }
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setButtonPosition(undefined);
  }, []);

  return {
    model,
    user,
    openModal,
    closeModal,
    buttonRef: buttonPosition?.element, // For backward compatibility with SideBarModal
    isOpen,
    buttonPosition,
  };
};
